import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToId } from "@/components/SmoothScroll";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#2D323D]/90 backdrop-blur-xl border-b border-[#E7B459]/20 shadow-[0_8px_30px_-8px_rgba(0,0,0,0.6)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto w-full flex items-center justify-between px-6 md:px-12 py-4">
        <button
          onClick={() => scrollToId("top")}
          data-testid="brand-wordmark"
          className="font-logo text-3xl font-bold tracking-tight text-[#F4F1ED]"
        >
          Raahi<span className="text-[#D9544E]">.</span>
        </button>

        <button
          onClick={() => scrollToId("waitlist")}
          data-testid="header-join-waitlist-btn"
          className="rounded-full bg-[#D9544E] text-[#F4F1ED] text-sm font-semibold px-5 py-2.5 hover:bg-[#c4423d] transition-colors duration-200"
        >
          Join the Waitlist
        </button>
      </div>
    </motion.header>
  );
}
